import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3243cb76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full sm:h-[240px] h-auto bg-[#F5F7F9] lg:pt-0 pt-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold sm:text-center text-left mb-8" }, "파충류 다 있다 서비스 안내", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sm:text-center text-left mt-4" }, [
  /*#__PURE__*/_createTextVNode(" 파충류 다 있다는 모든 생물 거래에 대하여 통신판매중개자로서 거래 당사자가 아닙니다. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 거래 회원 간의 생물 거래 정보 및 거래에 관여하지 않고 어떠한 의무와 책임도 부담하지 않습니다. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sm:text-center text-left" }, "Ⓒ pada All rights reserved.", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'Section9Footer',
  setup(__props) {

const openTerm = () => {
  window.open(
    "https://pada.s3.ap-northeast-2.amazonaws.com/paper/html/modi_agree1.html",
    "_blank",
    "width=800,height=600"
  );
};

const openPrivacy = () => {
  window.open(
    "https://pada.s3.ap-northeast-2.amazonaws.com/paper/html/1219_tradingPolicy.html",
    "_blank",
    "width=800,height=600"
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "max-w-4xl mx-auto text-[#838383] text-xs sm:flex-row flex-col p-0 flex justify-center" }, [
      _createElementVNode("div", { class: "sm:w-7/12 w-full lg:space-y-4 space-y-2 mt-4 lg:mt-6 px-4" }, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", { class: "mt-4 space-x-5 sm:flex justify-center block mb-4" }, [
          _createElementVNode("button", { onClick: openTerm }, "이용약관"),
          _createElementVNode("button", { onClick: openPrivacy }, "개인정보처리방침")
        ]),
        _hoisted_4,
        _hoisted_5
      ])
    ])
  ]))
}
}

})